import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "rounded-lg border border-gray-200 bg-white p-6" }
const _hoisted_2 = { class: "flex items-start justify-between gap-4" }
const _hoisted_3 = { class: "min-w-0" }
const _hoisted_4 = { class: "text-xs uppercase tracking-wider text-gray-500" }
const _hoisted_5 = {
  key: 0,
  class: "mt-1 text-sm text-gray-500"
}
const _hoisted_6 = { class: "shrink-0 text-right" }
const _hoisted_7 = { class: "text-3xl font-bold leading-none text-gray-900" }
const _hoisted_8 = {
  key: 0,
  class: "mt-5 space-y-2 border-t border-gray-100 pt-4"
}
const _hoisted_9 = ["data-row"]
const _hoisted_10 = { class: "text-sm text-gray-600" }
const _hoisted_11 = { class: "text-sm font-semibold tabular-nums text-gray-900" }
const _hoisted_12 = {
  key: 1,
  class: "mt-5 border-t border-gray-100 pt-4 text-sm text-gray-500"
}

import ReportDelta from '@/components/reports/ReportDelta.vue'


export default {
  __name: 'SignupSourceCard',
  props: {
  label: { type: String, required: true },
  value: { type: String, required: true },
  caption: { type: String, default: '' },
  delta: { type: Number, default: undefined },
  // [{ key, label, value }] - a breakdown of this card's own number.
  rows: { type: Array, default: () => [] },
  emptyText: { type: String, default: '' }
},
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(__props.label), 1),
        (__props.caption)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.caption), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(__props.value), 1),
        (__props.delta !== undefined)
          ? (_openBlock(), _createBlock(ReportDelta, {
              key: 0,
              class: "mt-2 block text-sm",
              delta: __props.delta
            }, null, 8, ["delta"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (__props.rows.length)
      ? (_openBlock(), _createElementBlock("dl", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rows, (row) => {
            return (_openBlock(), _createElementBlock("div", {
              key: row.label,
              class: "flex items-baseline justify-between gap-4",
              "data-row": row.key
            }, [
              _createElementVNode("dt", _hoisted_10, _toDisplayString(row.label), 1),
              _createElementVNode("dd", _hoisted_11, _toDisplayString(row.value), 1)
            ], 8, _hoisted_9))
          }), 128))
        ]))
      : (__props.emptyText)
        ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(__props.emptyText), 1))
        : _createCommentVNode("", true)
  ]))
}
}

}